import { getErrorCode, getErrorResponse, getErrorStatus } from '../../../../../common/api/errors'
import { ValidationError } from './types'

const PROFILE_VALIDATION_FAILED = 'MATCHING_PROFILE_VALIDATION_FAILED'

/**
 * Normalizes what this section's endpoints can throw into something showable.
 *
 * Matching's refusal of a profile write arrives as 422 MATCHING_PROFILE_VALIDATION_FAILED with
 * `errors` = one entry per field plus an optional `general_error` for a refusal without a field;
 * every other error is the backend's `errors.general_error`. The `/internal/matching/profiles` URL
 * is carved out of the axios interceptor's generic error toast, so whatever this function misses is
 * shown to the operator as silence.
 */
export const readApiError = (e: unknown, fallback = 'Не удалось выполнить операцию'): {
  errors: ValidationError[]
  message: string
} => {
  const body = getErrorResponse<unknown>(e)
  const map = body && typeof body === 'object' && !Array.isArray(body) ? (body as Record<string, unknown>) : null

  if (getErrorCode(e) === PROFILE_VALIDATION_FAILED && map) {
    // `message` is filled here too: callers without a form to highlight (the
    // «Активен» switch, delete) still need the concrete reason, not the fallback.
    const errors: ValidationError[] = Object.entries(map)
      .filter((entry): entry is [string, string] => typeof entry[1] === 'string' && entry[1] !== '')
      .map(([key, message]) =>
        key === 'general_error'
          ? { code: PROFILE_VALIDATION_FAILED, message }
          : { code: PROFILE_VALIDATION_FAILED, message, fields: [key] }
      )
    const texts = Array.from(new Set(errors.map((x) => x.message)))
    return { errors, message: texts.length ? texts.join('\n') : fallback }
  }

  const texts: string[] = []
  if (map) {
    Object.values(map).forEach((v) => {
      if (typeof v === 'string' && v) texts.push(v)
    })
  }

  const status = getErrorStatus(e)
  const suffix = status ? ` (${status})` : ''
  return { errors: [], message: texts.length ? texts.join('\n') : `${fallback}${suffix}` }
}
